import { GetTextStylesDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

interface useGetTextStylesProps {
  searchText: string | undefined;
  skip: boolean;
}

export function useGetTextStyles({ searchText, skip }: useGetTextStylesProps) {
  const TEXT_STYLES_LIMIT = 8;

  const { data, loading, fetchMore } = useQuery(GetTextStylesDocument, {
    fetchPolicy: "cache-first",
    variables: {
      offset: 0,
      limit: TEXT_STYLES_LIMIT,
      searchText: searchText ?? undefined,
    },
    skip,
  });

  const items = data?.getTextStyles.items;
  const hasMore = data?.getTextStyles.hasMore ?? false;

  const loadMore = () => {
    fetchMore({
      variables: {
        limit: TEXT_STYLES_LIMIT,
        offset: items?.length ?? 0,
        searchText: searchText ?? undefined,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        return {
          getTextStyles: {
            ...fetchMoreResult.getTextStyles,
            items: [...prev.getTextStyles.items, ...fetchMoreResult.getTextStyles.items],
          },
        };
      },
    });
  };

  return {
    textStyles: items,
    hasMore,
    loadMore,
    loading,
    TEXT_STYLES_LIMIT,
  };
}
